/**
 * Config
 * ------
 * High level general purpose variables and settings
 */

window.$b = $('body');
window.$w = $(window);

// app variables and functions
window.site = {
	breakpoints : {
	    xs: 0,
	    md: 768,
	    lg: 1025,
	    xl: 1536
  },
  ac : 'active',
  hc : 'hidden'
};

String.prototype.slugify = function(end) {

  return this.toLowerCase().substring(0, end)
      .replace(/\s+/g, '-')           // Replace spaces with -
      .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
      .replace(/\-\-+/g, '-')         // Replace multiple - with single -
      .replace(/^-+/, '')             // Trim - from start of text
      .replace(/-+$/, '');            // Trim - from end of text

};

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

String.prototype.truncateString = function(len, append)
{
  let newLength;

  //Optional: append a string to str after truncating. Defaults to an empty string if no value is given
  append = append || "";

  if (append.length > 0)
  {
      //Add a space to the beginning of the appended text
      append = " "+append;
  }
  if (this.indexOf(' ')+append.length > len)
  {
      //if the first word + the appended text is too long, the function returns the original String
      return this;
  }

  /*  if the length of original string and the appended string is greater than the max length, we need to truncate,
      otherwise, use the original string */
  this.length+append.length > len ? newLength = len-append.length : newLength = this.length;

  //cut the string at the new length
  let tempString = this.substring(0, newLength);
  //find the last space that appears before the substringed text
  tempString = tempString.replace(/\s+\S*$/, "");

  if (append.length > 0)
  {
      tempString = tempString + append;
  }

  console.log(tempString);
  return tempString;
};